import { NgModule, Component, OnInit } from '@angular/core';
import { AuthenticationService} from '@app/services/v1/authentication.service';
import { UserDataApi, LoopBackAuth } from '../../../../assets/js/lb-sdk/services';
import 'rxjs/add/operator/catch';
import { Router, RouterModule } from '@angular/router';
import { ProductsService, DiscountsService } from '../../../services';
import { HasRolePipe } from '../../../pipes/has-role.pipe';
import { USER_ROLES } from '../../../enums';
import { BsModalService } from 'ngx-bootstrap';
import { TermsAndConditionsAcceptComponent } from '../../administration/terms-and-conditions/terms-and-conditions-accept/terms-and-conditions-accept.component';
import { HttpClient } from '@angular/common/http';

interface Credential {
  username?: string;
  usercode?: string;
  remember: boolean;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  REGEX = {
    USERNAME: /^[a-zA-Z]+[a-zA-Z0-9_]*$/
  };

  error?: string;
  credential:Credential = {
    remember: false
  };

  constructor(
    private authService: AuthenticationService,
    private userDataApi: UserDataApi,
    private loopBackAuth: LoopBackAuth,
    private router: Router,
    private productService: ProductsService,
    private discountService: DiscountsService,
    private hasRole: HasRolePipe,
    private modalService: BsModalService,
    private http: HttpClient
  ) { }

  ngOnInit() { 
        // Load XSRF-TOKEN. ignore api error
        // this.http.get('/api').subscribe(value => value);
  }


  login(form) {
    if (form.valid) {
      this.error = undefined;
      this.userDataApi.login({
        username: this.credential.username,
        password: this.credential.usercode
      }, undefined, this.credential.remember)
      .subscribe(
        response => {
          this.authService.setUserData(response);
          this.loopBackAuth.setRememberMe(this.credential.remember);
          this.loopBackAuth.setToken(response);
          this.userDataApi
            .findById(response.userId, { include: { roles: 'role' } })
            .subscribe((user: any) => {
              this.loopBackAuth.setUser(user);
              if (user.partnerId) {
                this.userDataApi
                  .getUserMerchantDetails()
                  .subscribe(
                    details => {
                      user.merchantDetails = details;
                      this.loopBackAuth.setUser(user);
                      // LOAD DEPS
                      if (
                        this.hasRole.transform(user.roles, USER_ROLES.GENERAL_MERCHANT, '>=') &&
                        this.hasRole.transform(user.roles, USER_ROLES.AUH, '<')
                      ) {
                        this.discountService.loadDiscounts();
                      }
                      if (this.hasRole.transform(user.roles, USER_ROLES.AUH, '>=')) {
                        this.discountService.loadDiscounts();
                      }
                    },
                    error => {
                      this.error = error.message || 'Unable to get Merchant Details';
                    }
                  );
              }
              let proceed = (accepted, skipUpdate) => {
                if (accepted) {
                  // UPDATE USER
                  if (!skipUpdate) {
                    this.userDataApi.patchAttributes(user.id, {
                      termsAccepted: true
                    }).subscribe(updatedUser => {
                      this.loopBackAuth.setUser({
                        ...user,
                        ...updatedUser
                      });
                    });
                  }
                  // NAVIGATE
                  if (this.hasRole.transform(user.roles, USER_ROLES.ICT)) {
                    this.router.navigateByUrl('/users');
                  } else {
                    this.router.navigateByUrl('/dashboard');
                  }
                } else {
                  this.error = 'Terms and Conditions not accepted';
                  this.userDataApi
                    .logout()
                    .subscribe(() => {
                      this.loopBackAuth.clear();
                      localStorage.removeItem('orders');
                    });
                }
              };
              if (user.termsAccepted) {
                proceed(true, true);
              } else {
                this.terms({
                  accepted: false,
                }, proceed);
              }
            });
          this.productService.loadProductTypes();
        },
        error => {
          switch (error.code) {
            case 'LOGIN_FAILED':
              this.error = 'Invalid Credentials.';
              break;
            default:
              this.error = 'Unable to login' + (error.message ? '. ' + error.message : '.');
              break;
          }
        }
      );
    }
  }

  terms(data, next): void {
    const createModal = this.modalService
      .show(TermsAndConditionsAcceptComponent, {
        initialState: { data }
      });
    const subscription = this.modalService.onHidden
      .subscribe(() => {
        if (createModal.content) {
          if (createModal.content.result) {
            next(true);
          } else {
            next(false);
          }
        }
        subscription.unsubscribe();
      });
  }
}
